import React, { Component } from 'react';
import HomeHeader from '../partials/HomeHeader';
import Ourservices from '../partials/Ourservices';
import Quotes from '../partials/Quotes';
import LatestThinking from '../partials/LatestThinking';
import Ourtechnology from '../partials/Ourtechnology';
import Ourmission from '../partials/Ourmission';
import ManagementTeam from '../partials/ManagementTeam';
import Ourclients from '../partials/Ourclients';
import Homefooter from '../partials/Homefooter';
import * as Config from '../config/Config';

export default class HomeLayout extends Component {

  componentWillMount() {
    document.body.className="landing-page";
    document.body.id="";
  }

  render() {
    const appFullName = Config.appFullName;

    return (
    <div>
        <div id="mobNav" className="mobNav">
            <figure className="mobi-logo">
                <a href="/#/" title={appFullName}>
                <img src={process.env.PUBLIC_URL +'/images/logo-361dm.png'} alt={appFullName} />
                </a>
            </figure>
            <ul>
                <li><a href="javascript:void(0);">Partners</a></li>
                <li><a href="javascript:void(0);">Institutions</a></li>
                <li><a href="javascript:void(0);">Corporates</a></li>
                <li><a href="javascript:void(0);">Our Science</a></li>
                <li><a href="javascript:void(0);">Our technology</a></li>
                <li><a href="javascript:void(0);">Our Products</a></li>
                <li><a href="javascript:void(0);">Our Alliances</a></li>
                <li><a href="javascript:void(0);">361DM App</a></li>
                <li><a href="javascript:void(0);">Careers</a></li>
                <li>
                    <a href="javascript:void(0);">About Us</a>
                    <ul>
                        <li><a href="javascript:void(0);">Company profile</a></li>
                        <li><a href="javascript:void(0);">Tech Platform</a></li>
                        <li><a href="javascript:void(0);">>Media Centre</a></li>
                        <li><a href="javascript:void(0);">Students Corner</a></li>
                        <li><a href="javascript:void(0);">Alumni</a></li>
                        <li><a href="javascript:void(0);">Careers</a></li>
                        <li><a href="javascript:void(0);">Contact Us</a></li>
                        <li><a href="javascript:void(0);">Privacy</a></li>
                        <li><a href="javascript:void(0);">Terms</a></li>
                        <li><a href="javascript:void(0);">Legal</a></li>
                    </ul>
                </li>
                <li><a href="javascript:void(0);">Careers</a></li>
            </ul>
        </div>
        <div id="page">
            <HomeHeader redirect={this.props.redirect}/>
            <Ourservices/>
            <Quotes/>
            <LatestThinking/>
            <Ourtechnology/>
            <Ourmission/>
            <ManagementTeam/>
            <Ourclients/>
            <Homefooter/>
        </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/HomeLayout.js